import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const WenchRulerIcon = createIcon({
  displayName: 'WenchRulerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path
        d="M5.74,11.26,2.8,8.32a1.026,1.026,0,0,1,0-1.45L5.87,3.8a1.026,1.026,0,0,1,1.45,0L9.26,5.74"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M18.26,14.74l1.94,1.94a1.026,1.026,0,0,1,0,1.45L17.13,21.2a1.026,1.026,0,0,1-1.45,0l-2.94-2.94"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.76637,9.10207l-7.61779,7.6178a2.21437,2.21437,0,1,0,3.13159,3.13159l7.6178-7.6178"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.76637,9.10207a4.97792,4.97792,0,0,1,3.21314-6.35529,4.81879,4.81879,0,0,1,1.99219-.2229.99783.99783,0,0,1,.56787,1.7002l-1.8042,1.80414a.49989.49989,0,0,0,0,.70709l1.5293,1.52936a.50007.50007,0,0,0,.70715,0L19.7759,6.46053a.99781.99781,0,0,1,1.70019.56781,4.81674,4.81674,0,0,1-.2229,1.99219A4.97771,4.97771,0,0,1,14.898,12.23366"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const WenchRuler: FC<IconProps> = (props) => {
  return <CustomIcon as={WenchRulerIcon} {...props} />
}

export default memo(WenchRuler)
